import { SpriteData } from './SpriteData';
import { Resource } from './Resource';

export class SpriteResource extends Resource<SpriteData> {
  static readonly TypeId: string = 'sprite';

  constructor(id: string) {
    super(id);
  }

  get typeId(): string {
    return SpriteResource.TypeId;
  }
}
